module.exports = __webpack_public_path__ + "static/media/Montserrat-ExtraLight.f555c75a.woff";